import React from 'react';
import { Col, FormGroup } from 'reactstrap';
import { PlusCircle } from 'react-feather';

/**
 * AddOptionButton
 * - Tombol tambah opsi (+)
 * - Presentational only
 */
export default function AddOptionButton(props) {
  const { isVisible, onAdd } = props;

  if (!isVisible) return null;

  return (
    <Col className="col-1">
      <FormGroup className="mb-3">
        <PlusCircle onClick={onAdd} color="#3C6F7D" />
      </FormGroup>
    </Col>
  );
}